import defaultClient from '@src/api/clients/default';

// GET api/dashboard/lead-revenue/pipeline/?client_id&months
// -> monthly cohorts: leads, predicted pipeline $, realized-to-date, maturity
export function fetchLeadRevenuePipeline(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/lead-revenue/pipeline/',
    payload,
  });
}

// GET api/dashboard/lead-revenue/benchmark/?window_days (staff only)
// -> per client x vertical predicted vs realized decomposition
export function fetchLeadRevenueBenchmark(payload = {}) {
  return defaultClient.request({
    url: 'dashboard/lead-revenue/benchmark/',
    payload,
  });
}

export default {
  fetchLeadRevenuePipeline,
  fetchLeadRevenueBenchmark,
};
